import React, {useState} from "react"
import {FieldEditableMode, FieldEditableProps} from "../../../../proto/render/editable";
import {FieldViewSize} from "../../../../const";
import FieldRating_EditableStateful from "./rating-component";
import FieldRating from "../../rating";
import {isBulkSelection} from "../../../../../gd/right-click-menu";

const debug = false
// const debug = "FieldRating_Editable"

export default function FieldRating_Editable(props:FieldEditableProps) {


    // STATE & hovered
    const [mode, setMode] = useState(FieldEditableMode.VIEW)

    const onMouseEnter = () => {
        if (props.disabled || !props.field.canEdit(props.model)) return false

        if (mode === FieldEditableMode.VIEW) {
            setMode(FieldEditableMode.HOVERED)
        }
    }

    const onMouseLeave = () => {
        if (mode===FieldEditableMode.HOVERED) setMode(FieldEditableMode.VIEW)
    }

    const onDeleteClick = (e:React.MouseEvent) => {
        if (isBulkSelection(e)) return
        e.stopPropagation()

        onChange(null)
    }

    const onChange = (newValue:any) => {
        props.onChange && props.onChange(newValue)

        setMode(FieldEditableMode.VIEW)
    }


    const canEdit       = !props.disabled && props.field.canEdit(props.model)
    const value         = props.field.getViewValue(props.model)
    // const displayValue  = props.field.getDisplayValue(value)

    const classes = Classes("ui5-field-editable", props.className, {
        "size-default"                  : props.size === FieldViewSize.DEFAULT,
        "size-small"                    : props.size === FieldViewSize.SMALL,
    })

    const renderHovered = () => {

        const value         = props.field.getViewValue(props.model)
        const displayValue  = props.field.getDisplayValue(value)
        const hoveredClasses = Classes(classes, "is-hovered")

        return (
            <div className={hoveredClasses} onMouseLeave={onMouseLeave} >
                <FieldRating_EditableStateful field={props.field as FieldRating} value={value} onChange={props.onChange} disabled={!canEdit}/>

                <div className="buttons">
                    {!!displayValue && <div className="btn-reset" onClick={onDeleteClick}/>}
                </div>
            </div>
        )
    }

    const renderView = () => {

        return (
            <div className={classes} onMouseEnter={onMouseEnter}>
                <FieldRating_EditableStateful field={props.field as FieldRating} value={value} onChange={props.onChange} disabled={!canEdit}/>
            </div>
        )
    }



    switch (mode) {

        case FieldEditableMode.HOVERED:
            return renderHovered()

        case FieldEditableMode.VIEW:
        default:
            return renderView()
    }
}
